import type { ImageLoaderProps } from 'next/image';
import { ASSETS_ORIGIN } from '@/utils/storage/buckets';

/** Two widths keep Cloudflare Images variants (billed per source × params) to two per image. */
export const ASSET_WIDTHS = [384, 1000] as const; // 1000 = the max width uploads are stored at

/**
 * Tone images and avatars on `assets.` resize through Cloudflare Images. Anything else (rows not yet
 * flipped, external URLs) keeps Vercel's optimizer, so this can ship before the flip.
 */
export function cloudflareLoader({ src, width, quality }: ImageLoaderProps): string {
  if (!src.startsWith(`${ASSETS_ORIGIN}/`)) {
    return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality ?? 75}`;
  }
  return `${ASSETS_ORIGIN}/cdn-cgi/image/${assetImageOptions(width)}/${src.slice(ASSETS_ORIGIN.length + 1)}`;
}

/**
 * The only option strings we request, so the zone's WAF rule can allow exactly these. Quality is
 * fixed (a caller's would add variants); onerror=redirect serves the original if a resize fails.
 */
export function assetImageOptions(width: number): string {
  const w = ASSET_WIDTHS.find((b) => b >= width) ?? ASSET_WIDTHS[ASSET_WIDTHS.length - 1];
  return `width=${w},fit=scale-down,format=auto,quality=80,onerror=redirect`;
}
